const anchor = {
  onLoad: () => {
    let dom = {};
    dom.anchors = [...document.querySelectorAll('[data-anchor]')];
    dom.menu = [...document.querySelectorAll('[data-target]')];
    dom.eiHeader = document.querySelector('#ei_tpl_head_center');
    dom.header = document.querySelector('#ei_tpl_content > header');
    dom.toTop = document.querySelector('.scrollTop');
    dom.aside = document.querySelector('.section__wrapper > aside');
    dom.headerCIC = document.querySelector('#ei_tpl_menuPrincipal') || '';

    anchor.onClick(dom);
    anchor.onScroll(dom);
  },
  onScroll: (dom) => {
    window.addEventListener('scroll', function () {
      let eiCICHeaderHeight = 0;
      if (window.location.href.indexOf('cic')) {
        eiCICHeaderHeight = dom.headerCIC.offsetHeight;
      }

      const eiHeaderHeight = dom.eiHeader.offsetHeight;
      const headerHeight = dom.header.offsetHeight;
      //encore du crado rapidos vilain Carl
      function closestToZero(numbers) {
        if (!numbers.length) {
          return 0;
        }

        let closest = 0;

        for (let i = 0; i < numbers.length; i++) {
          if (closest === 0) {
            closest = numbers[i];
            dom.menu[i].parentElement.classList.add('active');

            dom.menu.forEach((el, index) => {
              if (index !== i) {
                el.parentElement.classList.remove('active');
              }
            });
          } else if (numbers[i] > 0 && numbers[i] <= Math.abs(closest)) {
            closest = numbers[i];
            dom.menu[i].parentElement.classList.add('active');

            dom.menu.forEach((el, index) => {
              if (index !== i) {
                el.parentElement.classList.remove('active');
              }
            });
          } else if (numbers[i] < 0 && -numbers[i] < Math.abs(closest)) {
            closest = numbers[i];
            dom.menu[i].parentElement.classList.add('active');
            dom.menu.forEach((el, index) => {
              if (index !== i) {
                el.parentElement.classList.remove('active');
              }
            });
          }
        }

        return closest;
      }

      let anchorsPos = [];
      dom.anchors.forEach((el) => {
        anchorsPos.push(el.getBoundingClientRect().top - (eiHeaderHeight + headerHeight + eiCICHeaderHeight) + 30);
      });

      closestToZero(anchorsPos);
    });
  },
  onClick: (dom) => {
    dom.toTop.addEventListener('click', function (e) {
      window.scroll(0, 0);
    });

    dom.menu.map((el, index) => {
      const target = document.querySelector(`[data-anchor="${el.dataset.target}"]`);

      el.addEventListener('click', function () {
        let eiCICHeaderHeight = 0;
        if (window.location.href.indexOf('cic')) {
          eiCICHeaderHeight = dom.headerCIC.offsetHeight;
        }

        const eiHeaderHeight = dom.eiHeader.offsetHeight;
        const headerHeight = dom.header.offsetHeight;

        dom.menu.map((anchor, i) => {
          if (i !== index) {
            anchor.parentElement.classList.remove('active');
          }
        });

        el.parentElement.classList.add('active');

        window.scroll(0, target.getBoundingClientRect().top + window.scrollY - (eiHeaderHeight + headerHeight + eiCICHeaderHeight) - 50);
        dom.aside.classList.remove('open');
      });
    });
  },
  init: () => {
    anchor.onLoad();
  },
};

const header = {
  onLoad: () => {
    let dom = {};
    dom.headerCIC = document.querySelector('#ei_tpl_menuPrincipal');
    dom.eiHeader = document.querySelector('#ei_tpl_head_center');
    dom.header = document.querySelector('#ei_tpl_content > header');

    header.onScroll(dom);
  },
  onScroll: (dom) => {
    const eiHeaderHeight = dom.eiHeader.offsetHeight;

    let eiCICHeaderHeight = 0;
    let headerPos = 0;
    let headerHeight = 0;

    if (window.location.href.indexOf('cic') > 0 || window.location.href.indexOf('becm') > 0 || window.location.href.indexOf('banquetransatlantique') > 0) {
      eiCICHeaderHeight = dom.headerCIC.offsetHeight;
    }

    if (window.location.href.indexOf('cmne') > 0) {
      headerHeight = 7;
    } else {
      headerHeight = eiCICHeaderHeight + eiHeaderHeight;
    }

    headerPos = dom.header.getBoundingClientRect().top - (eiHeaderHeight + eiCICHeaderHeight);

    window.addEventListener('scroll', function () {
      if (window.scrollY > headerPos) {
        dom.header.style.top = `${headerHeight - 7}px`;
        dom.header.classList.add('mini');
      } else {
        dom.header.classList.remove('mini');
        dom.header.style.top = 0;
      }
    });
  },
  init: () => {
    header.onLoad();
  },
};

const nav = {
  onLoad: () => {
    let dom = {};
    dom.eiHeader = document.querySelector('#ei_tpl_head_center');
    dom.header = document.querySelector('#ei_tpl_content > header');
    dom.nav = document.querySelector('aside > ul');
    dom.mobileNav = document.querySelector('.mobileNav');
    dom.aside = document.querySelector('.section__wrapper > aside');
    dom.close = document.querySelector('.closeNav');
    dom.toTop = document.querySelector('.scrollTop');
    dom.headerCIC = document.querySelector('#ei_tpl_menuPrincipal') || '';

    if (window.innerWidth < 961) {
      dom.nav.classList.add('hidden');
    }

    nav.onScroll(dom);
    nav.onResize(dom);
    nav.onClick(dom);
  },
  onClick: (dom) => {
    dom.mobileNav.addEventListener('click', function (e) {
      e.preventDefault();
      dom.nav.classList.remove('hidden');
      dom.aside.classList.toggle('open');
    });

    dom.close.addEventListener('click', function (e) {
      e.preventDefault();
      dom.aside.classList.remove('open');
    });
  },
  onResize: (dom) => {
    window.addEventListener('resize', function () {
      if (window.innerWidth > 960) {
        dom.nav.classList.remove('hidden');
      } else {
        dom.nav.classList.remove('sticky');
        dom.nav.classList.add('hidden');
      }
    });
  },
  onScroll: (dom) => {
    const headerHeight = dom.header.offsetHeight;
    const navPos = dom.nav.getBoundingClientRect().top - headerHeight;
    window.addEventListener('scroll', function () {
      if (window.scrollY > navPos && window.innerWidth > 960) {
        dom.nav.classList.add('sticky');
        dom.nav.classList.remove('hidden');
      }
      if (this.window.scrollY < navPos && window.innerWidth > 960) {
        dom.nav.classList.remove('sticky');
      }
      if (dom.toTop.getBoundingClientRect().top < 750 && window.innerWidth > 960) {
        dom.nav.classList.remove('sticky');
      }
    });
  },
  init: () => {
    nav.onLoad();
  },
};

document.addEventListener('DOMContentLoaded', function () {
  header.init();
  nav.init();
  anchor.init();
});
